/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Warehouse_Sales_Kpi_Out_Of_StockInputs */

const vi_warehouse_sales_kpi_out_of_stock = /** @type {(inputs: Warehouse_Sales_Kpi_Out_Of_StockInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã hết hàng: ${i?.count}`)
};

/**

* @param {Warehouse_Sales_Kpi_Out_Of_StockInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_kpi_out_of_stock = /** @type {((inputs: Warehouse_Sales_Kpi_Out_Of_StockInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Kpi_Out_Of_StockInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_kpi_out_of_stock(inputs)
});